// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.jabil-link {
  color: #287bbd;
  text-decoration: none;
}

.jabil-link:hover {
  color: #a2d0f3;
}

img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}`, "",{"version":3,"sources":["webpack://./src/app/core/controls/jabil-table/jabil-table.component.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,qBAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;AACF","sourcesContent":[".jabil-link {\r\n  color: #287bbd;\r\n  text-decoration: none;\r\n}\r\n\r\n.jabil-link:hover {\r\n  color: #a2d0f3;\r\n}\r\n\r\nimg {\r\n  max-width: 100%;\r\n  max-height: 100%;\r\n  object-fit: contain;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
